<template>
    <MainContent title="Resumen de categoría">
        <!-- Skeleton: stats cards -->
        <template v-if="loading">
            <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-6 tw:mb-6">
                <Card>
                    <Skeleton padding="tw:p-0" variant="tw:bg-transparent" customClass="tw:w-full">
                        <template #skeleton>
                            <div class="tw:space-y-5">
                                <SkeletonItem height="tw:h-4" customClass="tw:w-36 tw:rounded" />
                                <SkeletonItem height="tw:h-12" customClass="tw:w-12 tw:rounded-lg" />
                            </div>
                        </template>
                    </Skeleton>
                </Card>
                <Card>
                    <Skeleton padding="tw:p-0" variant="tw:bg-transparent" customClass="tw:w-full">
                        <template #skeleton>
                            <div class="tw:space-y-5">
                                <SkeletonItem height="tw:h-4" customClass="tw:w-20 tw:rounded" />
                                <SkeletonItem height="tw:h-12" customClass="tw:w-28 tw:rounded-lg" />
                            </div>
                        </template>
                    </Skeleton>
                </Card>
            </div>

            <!-- Skeleton: buscador + botones -->
            <Card custom-classes="tw:mb-6">
                <Skeleton padding="tw:p-0" variant="tw:bg-transparent" customClass="tw:w-full">
                    <template #skeleton>
                        <div class="tw:flex tw:flex-col tw:lg:flex-row tw:gap-4 tw:items-center tw:justify-between">
                            <SkeletonItem height="tw:h-10" customClass="tw:w-full tw:lg:max-w-sm tw:rounded-lg" />
                            <div class="tw:flex tw:gap-2">
                                <SkeletonItem height="tw:h-9" customClass="tw:w-24 tw:rounded-lg" />
                                <SkeletonItem height="tw:h-9" customClass="tw:w-36 tw:rounded-lg" />
                            </div>
                        </div>
                    </template>
                </Skeleton>
            </Card>
        </template>

        <!-- Real content -->
        <template v-else>
            <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-6 tw:mb-6">
                <StatsCard
                    title="NÚMERO DE DEPORTISTAS"
                    :value="resumen.total_deportistas"
                    :loading="loading"
                />
                <StatsCard
                    title="EDAD MEDIA"
                    :value="resumen.media_edad ? resumen.media_edad + ' años' : ''"
                    :loading="loading"
                />
            </div>

            <Card custom-classes="tw:mb-6">
                <div class="tw:flex tw:flex-col tw:lg:flex-row tw:gap-4 tw:items-center tw:justify-between">
                    <div class="tw:w-full tw:lg:max-w-sm">
                        <SearchComponent v-model="search" />
                    </div>
                    <div class="tw:flex tw:gap-2 tw:shrink-0">
                        <Button as="a" :href="urlDescargaInforme" target="_blank">
                            Informe
                        </Button>
                        <Button as="a" :href="urlDescargaListado" target="_blank">
                            Descargar listado
                        </Button>
                    </div>
                </div>
            </Card>
        </template>

        <ResumenDeportistas :search="search" />
    </MainContent>
</template>

<script setup>
    import { ref } from 'vue'
    import { useCategoriaResumen } from '@/composables/admin/bases/useCategoriaResumen'
    import MainContent from '@/modules/admin/ui/MainContent.vue'
    import Card from '@/modules/admin/ui/Card.vue'
    import SearchComponent from '@/modules/admin/ui/SearchComponent.vue'
    import StatsCard from '@/modules/admin/ui/StatsCard.vue'
    import Button from '@/modules/admin/ui/Button.vue'
    import { Skeleton, SkeletonItem } from '@/modules/admin/ui/skeleton'
    import ResumenDeportistas from '../components/ResumenDeportistas.vue'

    const search = ref('')

    const { resumen, categoria, loading, urlDescargaInforme, urlDescargaListado } = useCategoriaResumen()
</script>
